import { render, staticRenderFns } from "./rightCenter.vue?vue&type=template&id=5a41b4ab&scoped=true"
import script from "./rightCenter.vue?vue&type=script&lang=js"
export * from "./rightCenter.vue?vue&type=script&lang=js"
import style0 from "./rightCenter.vue?vue&type=style&index=0&id=5a41b4ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a41b4ab",
  null
  
)

export default component.exports